"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = exports.AlertContainer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = __importDefault(require("../styles/theme"));
const icon_1 = require("./icon");
const styled_div_1 = __importDefault(require("./styled-div"));
const typography_1 = require("../styles/typography");
exports.AlertContainer = styled_components_1.default.div `
  padding: ${(props) => props.onClose
    ? `${props.theme.spacing.s}`
    : `1.1rem ${props.theme.spacing.s}`};

  border-radius: ${(props) => props.theme.borderRadius};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(props) => !props.borderless && `${typography_1.smallText}`}

  ${(props) => props.error &&
    `
    background-color: ${props.theme.colors.backgroundError};
    border: 1px ${props.theme.colors.error} solid;
    color: ${props.theme.colors.error};
  `}

  ${(props) => props.success &&
    `
    background-color: ${props.theme.colors.backgroundPrimaryAccent};
    border: 1px ${props.theme.colors.primaryAccent} solid;
    color: ${props.theme.colors.textDark};
  `}

  ${(props) => props.warning &&
    `
    background-color: ${props.theme.colors.backgroundWarning};
    border: 1px ${props.theme.colors.warning} solid;
    color: ${props.theme.colors.textDark};
  `}

  ${(props) => props.disclaimer &&
    `
    background-color: transparent;
    border: none; 
    color: ${props.theme.colors.textInactive};
  `}
  ${(props) => props.borderless &&
    `
    ${typography_1.defaultText}
    border-style: none;
    padding: 8px 10px;
    width: fit-content;
    border-radius: 4px;
  `}
`;
const Alert = ({ children, className, id, style, error = true, success = false, warning = false, disclaimer = false, focusOnRender = false, icon = false, borderless = false, onClose, }) => {
    const ref = react_1.useRef(null);
    react_1.useEffect(() => {
        var _a;
        if (focusOnRender)
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [focusOnRender, ref]);
    let iconType = 'error_outline_icon';
    let iconColor = theme_1.default.colors.error;
    if (warning) {
        iconType = 'warning_amber_outline_icon';
        iconColor = theme_1.default.colors.warning;
    }
    else if (success) {
        iconType = 'check_circle_outline_icon';
        iconColor = theme_1.default.colors.primaryAccent;
    }
    else if (disclaimer) {
        iconType = 'info_outline_icon';
        iconColor = theme_1.default.colors.textInactive;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.AlertContainer, { className: className, id: id, style: style, ref: ref, role: "alert", error: error, success: success, warning: warning, tabIndex: -1, disclaimer: disclaimer, onClose: onClose, borderless: borderless },
            react_1.default.createElement(styled_div_1.default, { flex: true },
                icon && (react_1.default.createElement(icon_1.Icon, { name: iconType, color: iconColor, style: { verticalAlign: 'bottom', marginRight: '5px' } })),
                children),
            onClose && (react_1.default.createElement(icon_1.IconButton, { ariaLabel: "clear", color: iconColor, name: "close", onClick: onClose })))));
};
exports.Alert = Alert;
exports.default = exports.Alert;
